export default "__VITE_ASSET__4mItbh8u__"